import { gql } from 'apollo-angular';
import {
  CreateReportTemplateMutation,
  CreateReportTemplateMutationVariables,
  DeleteReportTemplateMutation,
  DeleteReportTemplateMutationVariables,
  ReportTemplateListQuery,
  ReportTemplateListQueryVariables,
  ReportTemplateQuery,
  ReportTemplateQueryVariables,
  UpdateReportTemplateMutation,
  UpdateReportTemplateMutationVariables,
} from 'gql/graphql';

export const getRequestLTPayloadQuery = gql`
  query GetRequestLTPayload {
    getRequestLTPayload {
      allPropertiesLTValid
      RequestLTPayload
    }
  }
`;
export const postHTMLpropertyLTMutation = gql`
  mutation postHTMLpropertyLT($payload: JSON!) {
    postHTMLpropertyLT(payload: $payload) {
      html
    }
  }
`;

export const reportListQuery = gql`
  query ReportList {
    reportList {
      id
      name
      date
      author {
        id
        name
        lastName
      }
      category {
        id
        name
      }
      format
    }
  }
`;

export const reportTemplateListQuery = gql<
  ReportTemplateListQuery,
  ReportTemplateListQueryVariables
>`
  query ReportTemplateList {
    reportTemplateList {
      id
      name
      description
      categoryType
      author {
        id
        name
        lastName
      }
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
      }
    }
  }
`;

export const reportTemplateQuery = gql<
  ReportTemplateQuery,
  ReportTemplateQueryVariables
>`
  query ReportTemplate($id: ID!) {
    reportTemplate(id: $id) {
      id
      name
      description
      categoryType
      author {
        id
        name
        lastName
      }
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
      }
    }
  }
`;

export const reportCategoryListQuery = gql`
  query ReportCategoryList {
    reportCategoryList {
      id
      name
      type
      format
    }
  }
`;

export const reportCategorySelectOptionsQuery = gql`
  query ReportCategorySelectOptions {
    reportCategoryList {
      id
      name
    }
  }
`;

export const reportExportQuery = gql`
  query ReportExport($id: ID!) {
    reportExport(id: $id) {
      id
      filename
      contentType
      size
      content
    }
  }
`;

export const deleteReport = gql`
  mutation DeleteReport($id: ID!) {
    deleteReport(id: $id)
  }
`;

export const createReportMutation = gql`
  mutation CreateReport($input: ReportInput!) {
    createReport(input: $input) {
      id
      name
      date
      author {
        id
        name
        lastName
      }
      category {
        id
        name
      }
      format
    }
  }
`;

export const createReportTemplateMutation = gql<
  CreateReportTemplateMutation,
  CreateReportTemplateMutationVariables
>`
  mutation CreateReportTemplate($input: ReportTemplateInput!) {
    createReportTemplate(input: $input) {
      id
      name
      categoryType
      description
      author {
        id
        name
        lastName
      }
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
      }
    }
  }
`;

export const deleteReportTemplateMutation = gql<
  DeleteReportTemplateMutation,
  DeleteReportTemplateMutationVariables
>`
  mutation DeleteReportTemplate($input: ID!) {
    deleteReportTemplate(input: $input) {
      id
      name
      description
      categoryType
      author {
        id
        name
        lastName
      }
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
      }
    }
  }
`;

export const updateReportTemplateMutation = gql<
  UpdateReportTemplateMutation,
  UpdateReportTemplateMutationVariables
>`
  mutation UpdateReportTemplate($input: UpdateReportTemplateInput!) {
    updateReportTemplate(input: $input) {
      id
      name
      categoryType
      description
      author {
        id
        name
        lastName
      }
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
      }
    }
  }
`;

export const addToReportHistoryMutation = gql`
  mutation AddToReportHistory(
    $id: ID!
    $filename: String!
    $type: REPORT_CATEGORY!
    $content: String
    $size: Int
  ) {
    addToReportHistory(id: $id, filename: $filename, type: $type, content: $content, size: $size) {
      id
      name
      date
      author {
        id
        name
        lastName
      }
      category {
        id
        name
      }
      format
    }
  }
`;
